var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "v-select-menu relative" }, [
    _c(
      "div",
      {
        staticClass:
          "v-select-menu__el relative block w-full bg-transparent appearance-none z-20 rounded-none",
        class: {
          "text-theme": _vm.themed,
          "text-black": !_vm.themed,
          "font-semibold pl-2 pr-7 py-2": !_vm.small && !_vm.large,
          "text-sm pl-2 pr-7 py-1": _vm.small,
          "text-lg py-1": _vm.large,
        },
        attrs: {
          required: _vm.required,
          id: _vm.id,
          "data-testid": _vm.testId,
        },
      },
      [_c("span", [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")])]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }